/* eslint-disable no-param-reassign */
/* eslint-disable no-useless-constructor */

/**
 * utility class
 */
export class OMT_Utils {
  /**
   * constructor
   */
  constructor() {
    //
  }

  /**
   * stylized log output
   * @param {string} msg msg to log
   * @param {string} color foreground color
   * @param {string} bgColor foreground color
   */
  static stylizedLog(msg, color = '#00FF00', bgColor = '#222') {
    console.log(`%c ${msg} `, `background: ${bgColor}; color: ${color}`);
  }

  // TODO: reconsider naming to avoid confusion
  /**
   * Creates base64 image of selected message object
   * @param {Object} msgObj
   * @returns {string}
   */
  static msgToBase64(msgObj) {
    if (!G._msgBmp) G._msgBmp = game.make.bitmapData(672, 354);

    msgObj.x = game.world.bounds.x;
    msgObj.y = game.world.bounds.y;
    msgObj.updateTransform();

    G._msgBmp.clear();
    G._msgBmp.drawGroup(msgObj);

    msgObj.destroy();
    const dataURL = G._msgBmp.canvas.toDataURL();
    // G._msgBmp.destroy();
    return dataURL;
  }
}
